import React, { useEffect, useState } from "react";
import { data } from "../data/item";
import { MdEdit, MdDelete } from "react-icons/md";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { ImCross } from "react-icons/im";
import toast from "react-hot-toast";
import Pagination from "../component/Pagenation";
import { getAllConfig, updateConfig,createConfig ,deleteConfig} from "../api/configapi";
import { createbooking, deletebooking, getAllbooking, updatebooking } from "../api/booking";

const Transaction = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [amount, setAmount] = useState("");
  const [pending, setPending] = useState("");
  const [item, setItem] = useState([]);
  const [editId, setEditId] = useState(null);
  const [dropDownId, setDropDownId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = item?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(item.length / itemsPerPage);

 

 const handleSubmit = async () => {
  if (!customerName || !amount || !pending) {
    toast.error("Please fill all fields");
    return;
  }

  const newItem = {
    id: editId || Date.now(),
    name: customerName,
    customerName,
    amount,
    pending,
  };

  if (editId) {
    try {
      await updatebooking(editId, newItem);
      const updated = item.map((d) =>
        d.id === editId ? { ...d, ...newItem } : d);

      const updatedList = await  getAllbooking();
      setItem(Array.isArray(updatedList?.data) ? updatedList.data : []);
     setItem(updated);
      setEditId(null);
      toast.success("Field updated successfully");

     
      setCustomerName("");
      setAmount("");
      setPending("");
      setMenuOpen(false);
    } catch (err) {
      console.error("Update Config Error:", err.response?.data || err);
      toast.error(err?.response?.data?.message || "Update failed");
    }
  } 
};


  const handleEdit = (id) => {

    const editItem = item.find((i) => i.id === id);
    if (editItem) {
      setCustomerName(editItem.event);
      setAmount(editItem.totalAmount);
      setPending(editItem.advanceAmount);
      setEditId(id);
      setMenuOpen(true);
    }
    else{
       toast.error("Item not found for editing.");
    }
  };


 

 const handleDelete = (id) => {
    deletebooking(id)
    .then((res) =>{
     const updated = item.filter((i) => i.id !== id); 
      setItem(updated);

    })
    .catch((err) =>{
      console.log(err)
    })
   
  }; 

  useEffect(() => {
    getAllbooking()
      .then((res) =>setItem(res.data))
      .catch((err) => console.log(err));
  },[]);

  return (
    <div className="px-5 md:px-10 mt-[5%]">
      <div className="flex justify-between">
        <h4 className="text-primary text-xl font-bold">பரிவர்த்தனை அட்டவணை</h4>
        <button
          className="bg-primary text-white px-4 py-2 rounded-md text-sm font-bold"
          onClick={() => setMenuOpen(true)}
        >
          சேர்
        </button>
      </div>

<div className="w-full overflow-x-auto mt-5 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent">
  <table className="min-w-[700px] w-full border border-gray-200 rounded-xl overflow-hidden shadow bg-white">
    <thead>
      <tr className="bg-primary text-white text-nowrap">
        {["எஸ்.எண்", "வாடிக்கையாளர் பெயர்", "தொகை", "நிலுவையில் உள்ள தொகை"].map((col, i) => (
          <th
            key={i}
            className="text-sm font-semibold px-5 py-4 text-left border-b"
          >
            {col}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {currentItems.map((datas, i) => (
        <tr key={datas.id} className="hover:bg-gray-50 transition">
          <td className="px-5 py-4 border-b text-sm text-gray-700">
            {indexOfFirstItem + i + 1}
          </td>
          <td className="px-5 py-4 border-b text-sm text-gray-700">
            {datas.event}
          </td>
          <td className="px-5 py-4 border-b text-sm text-gray-700">
            ₹{datas.totalAmount}
          </td>
          <td className="px-5 py-4 border-b text-sm text-red-500">
            ₹{datas.advanceAmount}
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  {totalPages > 1 && (
    <div className="mt-4">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
  )}
</div>



      {/* Modal */}
      {menuOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
          <div className="w-[320px] sm:w-[600px] bg-white rounded-md shadow-lg p-5">
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-primary font-bold text-lg">Transaction</h4>
              <ImCross
                fontSize={20}
                className="p-1 hover:text-red-600 cursor-pointer"
                onClick={() => setMenuOpen(false)}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Customer Name
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-4 py-2 text-sm"
                  placeholder="Enter name"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount</label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-4 py-2 text-sm"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">
                  Pending Amount
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-4 py-2 text-sm"
                  placeholder="Enter pending amount"
                  value={pending}
                  onChange={(e) => setPending(e.target.value)}
                />
              </div>
            </div>

            <button
              className="w-full mt-6 bg-primary  text-white text-sm font-medium py-2 rounded-md"
              onClick={handleSubmit}
            >
              {editId ? "Update" : "Submit"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transaction;
